
// export default CustomerView;
import React from "react";

import { Box, Card, Typography } from "@mui/material";
import Header from "../components/Header";

function FourZeroFour() {




  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "#f0f2f5",
        display: "flex",
        flexDirection: "column",
        overflow: "auto",
      }}
    >
      <Header/>
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          padding: 0,
          // width: "100%",
          alignItems: "center", // Center alignment
        }}
      >
        <Card
          sx={{
            backgroundColor: "rgba(0, 0, 0, 0)",
            width: { xs: "100%", sm: "50%", md: "40%" }, // Responsive width
            boxShadow: "none",
            padding: 2,
            marginTop:10
          }}
        >
          <Typography variant="h4" gutterBottom sx={{ textAlign: "center" }}>
               404 Not Found
          </Typography>

        </Card>
      </Box>
    </Box>
  );
}

export default FourZeroFour;
